/**
 * Product Mix Report Hook
 * @see Sprint - Rapport Product Mix
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getProductMixReport } from '../services/product-mix.service';
import type { ProductMixReportInput } from '@bstock/shared';

/**
 * Query key factory for product mix report
 */
export const productMixKeys = {
  all: ['product-mix-report'] as const,
  report: (params: ProductMixReportInput) =>
    [...productMixKeys.all, 'report', params] as const,
};

/**
 * Hook to get product mix report
 */
export function useProductMix(params: ProductMixReportInput | null) {
  return useQuery({
    queryKey: productMixKeys.report(params!),
    queryFn: () => getProductMixReport(params!),
    enabled: !!params && !!params.dateFrom && !!params.dateTo,
    placeholderData: keepPreviousData,
    staleTime: 60_000, // 1 minute
  });
}
